import { IInviteService, ITable, ITableRepository, TableOptions } from './interfaces';
import { Message } from '../../chat/message';
import { BehaviorSubject } from 'rxjs';
import { IPlayer } from '@base/features/player/model/interfaces';

export default abstract class BaseTablesRepository<T extends ITable> implements ITableRepository<ITable> {
  invite?: IInviteService;
  tables = new BehaviorSubject<ITable[]>([]);

  abstract add(table: TableOptions): T;

  getTables(): ITable[] {
    return this.tables.value;
  }

  delete(id: number) {
    this.tables.next(this.tables.value.filter((table) => table.tid !== id));
  }

  addPlayerOnTable(tableId: number, seat: number, player: IPlayer) {
    this.updateTableValue(tableId, (table) =>
      table.seats ? (table.seats[seat] = player) : (table.seats = [player])
    );
  }

  removePlayerOnTable(tableId: number, seat: number) {
    this.updateTableValue(tableId, (table) => (table.seats[seat] = undefined));
  }

  cleanTables(): void {
    this.tables.next([]);
  }

  addMessageOnTable(message: Message): void {
    if (!message.tid) return;
    this.updateTableValue(message.tid, (table) => table.addChatMessage(message));
  }

  updateTableValue(tableId: number, updator: (table: ITable) => void) {
    const newTables = [...this.tables.value];
    const table = newTables.find((t) => t.tid === tableId);
    if (!table) return;
    updator(table);
    this.tables.next(newTables);
  }

  updateDataTable(tableOptions: TableOptions): ITable {
    if (!tableOptions || tableOptions.tid === undefined || tableOptions.tid < 0) {
      throw new Error('updateDataTable: invalid table from network for adding');
    }
    let table = this.getTable(tableOptions.tid);

    if (!table) {
      table = this.add(tableOptions);
    } else {
      Object.assign(table, tableOptions);
    }

    return table;
  }

  getTable(id: number): ITable | undefined {
    return this.tables.value.find((t) => t.tid === id);
  }

  updatePlayerOnTable(tableId: number, seat: number, player?: IPlayer): void {
    if (player) {
      this.addPlayerOnTable(tableId, seat, player);
    } else {
      this.removePlayerOnTable(tableId, seat);
    }
  }

  checkParams(params: any, options?: any, me?: IPlayer): string | undefined {
    if (typeof params.tid != 'undefined') {
      if (params.tid < 0) {
        return 'invalid table id';
      }

      if (!this.getTable(params.tid)) {
        return "table doesn't exist";
      }

      if (options?.myTable && this.getTable(params.tid) !== me?.getTable()) {
        return "i'm not playing on this table";
      }
    }
  }
}
